import { handlers } from '_helpers';
import crFetch from '_helpers/fetch';

const { handleResponseAsync } = handlers;

async function getAll(machineID) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'GET',
        url: `/scheduledjobs?machineID=${machineID}`
      }))
  );
}

async function getById(scheduledJobID) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'GET',
        url: `/scheduledjobs/${scheduledJobID}`
      }))
  );
}

async function create(scheduledJob) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'POST',
        url: '/scheduledjobs',
        body: JSON.stringify(scheduledJob)
      }))
  );
}

async function update(scheduledJob) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'PUT',
        url: `/scheduledjobs/${scheduledJob.scheduledJobID}`,
        body: JSON.stringify(scheduledJob)
      }))
  );
}

// prefixed function name with underscore because delete is a reserved word in javascript
async function Delete(scheduledJobID) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'DELETE',
        url: `/scheduledjobs/${scheduledJobID}`
      }))
  );
}

const scheduledJobService = {
  getAll,
  getById,
  create,
  update,
  delete: Delete
};

export default scheduledJobService;
